import type { AppErrorCode } from "@/lib/error-config";

/** Typed application error. `code` selects user copy from error-config;
    `status` is the upstream HTTP status (0 = network); `detail` is the
    backend's human-readable reason, when one was given. */
export class RegistrationError extends Error {
  constructor(public code: AppErrorCode, public status: number, public detail?: string) {
    super(detail || code);
  }
}
